export function homeReducer (state, action) {
    return;
}
